<ion-header role="none">
  <ion-toolbar>
    <ion-title aria-hidden="true" [innerHTML]="video.title"></ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <h1 class="sr-only" [innerHTML]="video.title"></h1>
  <!-- Announces the current video when navigating between levels (Easier/Harder) -->
  <div class="cdk-visually-hidden" aria-live="polite" aria-atomic="true">
    {{ video?.title }}, {{ step }}
  </div>

  <div class="exercise-modal-body">
    <div class="video-slide-container">
      <ion-card>
        <div class="video-frame" [style.width.px]="vimeowidth()" [style.height.px]="vimeoheight()">
          <div class="video-transition-overlay" [class.visible]="isLoading">
            <div class="overlay-content">
              <svg class="play-icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="24" r="23" stroke="rgba(255,255,255,0.15)" stroke-width="2"/>
                <path d="M19 14.5v19l15-9.5-15-9.5z" fill="rgba(255,255,255,0.2)"/>
              </svg>
              <div class="loading-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
          <iframe *ngIf="isNativeIosApp; else standardFullscreenIframe"
            #videoIframe [src]="vimeourl"
            frameborder="0"
            allow="autoplay; picture-in-picture"
            (load)="onIframeLoaded($event)"></iframe>
          <ng-template #standardFullscreenIframe>
            <iframe #videoIframe [src]="vimeourl"
              mozallowfullscreen="true"
              webkitallowfullscreen="true"
              allowfullscreen="true"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              (load)="onIframeLoaded($event)"></iframe>
          </ng-template>
        </div>
      </ion-card>
    </div>
    <app-video-instructions [videoWidth]="vimeowidth()"></app-video-instructions>
  </div>
</ion-content>
<ion-footer class="exercise-footer">
  <div *ngIf="exercise && exercise.type == 'progressive'" class="divider-padding exercise-footer-actions">
    <ion-button [disabled]="exercise.istail || isBusy" class="left-button big-text-btn" color="success" (click)="toohard()"> < Easier </ion-button>
    <span class="step-button" [innerHTML]="step"></span>
    <ion-button [disabled]="exercise.istop || isBusy" class="right-button big-text-btn" color="danger" (click)="tooeasy()"> Harder > </ion-button>
  </div>

  <div *ngIf="exercise && exercise.type != 'progressive'" class="divider-padding exercise-footer-actions">
    <ion-button [disabled]="exercise.istail || isBusy" class="left-button big-text-btn" color="danger" (click)="toohard()">Previous</ion-button>
    <span class="step-button" [innerHTML]="step"></span>
    <ion-button [disabled]="exercise.istop || isBusy" class="right-button big-text-btn" color="success" (click)="tooeasy()">{{ 'common.next' | translate }}</ion-button>
  </div>
</ion-footer>